import React from 'react';
import {
  FaLinkedin,
  FaGithub,
  FaEnvelope,
  FaPhone,
  FaDownload,
  FaMapMarkerAlt,
  FaArrowUp,
} from 'react-icons/fa';
import { useI18n, useT } from '../i18n';
import CopyEmail from './CopyEmail';
import './Footer.css';

const Footer = () => {
  const t = useT();
  const { lang, setLanguage, languages } = useI18n();
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="site-footer" id="contact">
      <div className="container">
        <div className="footer-top">
          <div className="footer-cta">
            <span className="footer-cta-label">{t('footer.contactLabel')}</span>
            <h2 className="footer-cta-title">{t('footer.contactTitle')}</h2>
            <p className="footer-cta-text">
              {t('footer.contactText')}
            </p>

            <div className="footer-actions">
              <a href="mailto:hervetusse@gmail.com" className="footer-btn footer-btn-primary">
                <FaEnvelope />
                {t('footer.getInTouch')}
              </a>
              <a
                href={t('resume.file')}
                className="footer-btn footer-btn-secondary"
                download
              >
                <FaDownload />
                {t('hero.downloadCv')}
              </a>
            </div>
          </div>

          <div className="footer-reach">
            <span className="footer-reach-label">{t('footer.direct')}</span>
            <div className="footer-contact-list">
              <span className="footer-contact-pair">
                <a href="mailto:hervetusse@gmail.com" className="footer-contact-item">
                  <FaEnvelope />
                  <span>hervetusse@gmail.com</span>
                </a>
                <CopyEmail className="on-ink" />
              </span>
              <a href="tel:+27641704892" className="footer-contact-item">
                <FaPhone />
                <span>+27 64 170 4892</span>
              </a>
              <span className="footer-contact-item">
                <FaMapMarkerAlt />
                <span>{t('footer.location')}</span>
              </span>
            </div>

            <div className="footer-social">
              <a
                href="https://www.linkedin.com/in/herve-tusse-8a2479177/"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('a11y.linkedin')}
              >
                <FaLinkedin />
              </a>
              <a
                href="https://github.com/htusse"
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('a11y.github')}
              >
                <FaGithub />
              </a>
              <a
                href="mailto:hervetusse@gmail.com"
                className="footer-social-link"
                aria-label={t('a11y.email')}
              >
                <FaEnvelope />
              </a>
            </div>
          </div>
        </div>

        <nav className="footer-languages" aria-label={t('language.label')}>
          {languages.map((language) => (
            <button
              key={language.code}
              type="button"
              lang={language.code}
              className={`footer-language ${language.code === lang ? 'is-active' : ''}`}
              aria-current={language.code === lang ? 'true' : undefined}
              onClick={() => setLanguage(language.code)}
            >
              {language.nativeName}
            </button>
          ))}
        </nav>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <button className="footer-top-btn" onClick={scrollToTop}>
            {t('footer.backToTop')}
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
